import React from 'react';

import { formatNumber } from '@column/column-ui-kit';
import { DataTable, type DataTableColumnDef } from '@column/ui';

import { getTimestampColumn } from '~/components/Table';
import { CardTransaction } from '~/repositories/CardTransactionRepository';
import { TableTimeFormat } from '~/repositories/UserRepository';
import { formatString } from '~/util';

export type CardTransactionRow = CardTransaction;

const formatAmount = (amount?: { amount: number; currencyCode: string }): string => {
  if (!amount) {
    return '-';
  }

  return formatNumber(amount.amount, amount.currencyCode);
};

export const getCardTransactionColumns = (
  timeFormat: TableTimeFormat,
  onTimeFormatChange: (value: TableTimeFormat) => void
): DataTableColumnDef<CardTransactionRow>[] => [
  {
    header: 'Merchant Name',
    id: 'merchant',
    width: 'minmax(180px, 1fr)',
    cell: ({ row }) => <DataTable.TextCell weight="medium" value={row.cardAcceptorDetails?.name || '-'} />,
  },
  {
    header: 'Card ID',
    accessor: 'cardId',
    width: 'minmax(230px, 1.4fr)',
    cell: ({ value }) => <DataTable.TextCell displayVariant="monospaced" value={(value as string) || '-'} />,
  },
  {
    header: 'Type',
    accessor: 'type',
    width: 'minmax(140px, 0.8fr)',
    cell: ({ value }) => <DataTable.TextCell value={value ? formatString(value as string) : '-'} />,
  },
  {
    header: 'Cardholder Authorized',
    id: 'cardholderAuthorizedAmount',
    width: 'minmax(160px, 0.9fr)',
    cell: ({ row }) => <DataTable.TextCell value={formatAmount(row.totalAmounts?.cardholderAuthorized)} />,
  },
  {
    header: 'Cardholder Settled',
    id: 'cardholderSettledAmount',
    width: 'minmax(150px, 0.9fr)',
    cell: ({ row }) => <DataTable.TextCell value={formatAmount(row.totalAmounts?.cardholderSettled)} />,
  },
  getTimestampColumn<CardTransactionRow>({
    accessor: 'createdAt',
    timeFormat,
    onTimeFormatChange,
    width: 'minmax(150px, 0.8fr)',
    fallback: '-',
  }),
];
